import { gql } from '@apollo/client'

export const SET_ANTIGEN_TYPE = gql`
  mutation SetAntigenTypeTestSession($inputData: SetAntigenTypeTestSessionInput!) {
    setAntigenTypeTestSession(inputData: $inputData)
  }
`
